// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.less'
import 'amfe-flexible'
import './assets/theme/font.css'
import VueLazyload from 'vue-lazyload'
import VideoPlayer from 'vue-video-player'
import i18n from './i18n/i18n'
import { getSubdomain, getSecondLevelDomain } from './utils/index'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
const subDomain = getSubdomain()
const secondDomain = getSecondLevelDomain()
console.log('🚀 ~ subDomain:', subDomain)
Vue.prototype.$domain = subDomain.split('-')[1]
Vue.prototype.$secondDomain = secondDomain
Vue.use(VideoPlayer)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueLazyload)
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js